/**
 *
 * Departments14366
 *
 */

export const BULVAR_TSVETNOY = '4006045944000';
export const UK_TSVETNOY = '4525229783000';
export const MELIORA_PLACE = '4537119376000';
